import {
  returnCurrentTabID,
  returnCurrentTabStateJSON,
} from "@/lib/widgetHelperFunctions";
import workspacesTabsStore from "@/store/workspacesTabsStore";
import React from "react";
import { cubeDefaultWorkspaceTab } from "./helperFunctionsRGL";
import { resetIcon } from "@/components/icons/SVGIcons";
import ToolTipMappedSVGandButton from "../Sidebar/ToolTipMappedSVGandButton";

const ResetLayoutsToDefault = () => {
  const updateWholeTab = workspacesTabsStore((state) => state.updateWholeTab);
  const currentTabStateJSON = returnCurrentTabStateJSON();

  function onNewLayout() {
    const newState = cubeDefaultWorkspaceTab(currentTabStateJSON);
    const currentTabId = returnCurrentTabID();

    if (currentTabId !== undefined) {
      updateWholeTab(newState, currentTabId);
    }
  }

  const buttonDetails = {
    displayName: "Reset",
    icon: resetIcon,
  };

  return (
    <ToolTipMappedSVGandButton
      button={buttonDetails}
      onClickAction={onNewLayout}
      dataTestID={"reset-default-button"}
    />
  );
};

export default ResetLayoutsToDefault;
